var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0893 0.577452C8.41473 0.902889 8.41473 1.43053 8.0893 1.75596L2.84522 7.00004L8.0893 12.2441C8.41473 12.5696 8.41473 13.0972 8.0893 13.4226C7.76386 13.7481 7.23622 13.7481 6.91079 13.4226L1.07745 7.5893C0.752014 7.26386 0.752014 6.73622 1.07745 6.41079L6.91078 0.577452C7.23622 0.252015 7.76386 0.252015 8.0893 0.577452Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftWhite);
export default __webpack_public_path__ + "static/media/arrow-left-white.d325c242633587f2a3a2675f7c2b608f.svg";
export { ForwardRef as ReactComponent };